export enum FilterComparator {
	EQ = 'eq',
	NE = 'ne',
	GT = 'gt',
	GTE = 'gte',
	LT = 'lt',
	LTE = 'lte',
	IN = 'in',
	NIN = 'nin',
	STARTS_WITH = 'starts_with',
	ENDS_WITH = 'ends_with',
	CONTAINS = 'contains',
	EMPTY = 'empty',
	NOT_EMPTY = 'not_empty',
}

export type DynamicDateFilter =
	| {
			type: 'date';
			comparator: FilterComparator.EQ | FilterComparator.GT | FilterComparator.LT;
			value: string | null;
	  }
	| {
			type: 'empty';
			comparator: FilterComparator.EMPTY | FilterComparator.NOT_EMPTY;
			value?: undefined;
	  };

export type DynamicTextFilter =
	| {
			type: 'select';
			comparator: FilterComparator.EQ | FilterComparator.NE;
			selected: Array<string | { label: string; value: string }>;
	  }
	| {
			type: 'text';
			comparator:
				| FilterComparator.EQ
				| FilterComparator.NE
				| FilterComparator.STARTS_WITH
				| FilterComparator.ENDS_WITH
				| FilterComparator.CONTAINS;
			value: string;
	  }
	| {
			type: 'empty';
			comparator: FilterComparator.EMPTY | FilterComparator.NOT_EMPTY;
	  };

export type DynamicNumberFilter = {
	type: 'number';
	comparator:
		| FilterComparator.EQ
		| FilterComparator.GT
		| FilterComparator.GTE
		| FilterComparator.LT
		| FilterComparator.LTE;
	value: number;
};

export type DynamicUserFilter = {
	type: 'user' | 'customer';
	selected: Array<string | { id: string; name: string }>;
};

export type DynamicFilterValue = DynamicDateFilter | DynamicTextFilter | DynamicNumberFilter | DynamicUserFilter;
